import React,{useState} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus,faMinus} from '@fortawesome/free-solid-svg-icons'
import {BtnItemBlockInfo} from '@gull'

/**
 * Ligne d'article dans le formulaire de création d'un ordre de transfert.
 * Affiche l'image (avec modal carrousel + stock au clic), le stock disponible dans le commerce d'origine
 * sélectionné, et un stepper +/- pour ajuster la quantité à transférer (plafonnée à maxQuantity).
 *
 * @param {Object} value - Article à transférer { id, name, image, quantity, maxQuantity }
 * @param {Object} articleToList - Map complète des articles à transférer, indexée par id
 * @param {Function} setArticleToList - Setter pour mettre à jour la quantité de cet article
 * @param {number} [disponible] - Stock disponible dans le commerce d'origine (undefined si non chargé)
 * @param {string} style - Classes CSS de la ligne (alternance de couleur de fond)
 * @param {number} [posid] - Id de la section POS courante, transmis en wmsid à BtnItemBlockInfo
 */
const LineItemToTransform = (props) =>{
    const t =useTranslate()
    const [errorAddQte,setErrorAddQte]=useState(false)

    const handleClick = (name) =>{
        if(name=='plus'){
            if(props.value.quantity<props.value.maxQuantity){
                let currentItem = props.articleToList[props.value.id]
                currentItem.quantity = currentItem.quantity = props.value.quantity+1
                props.setArticleToList({...props.articleToList,[props.value.id]:currentItem})
                setErrorAddQte(false)
            }else{
                setErrorAddQte(t('qteReached'))
            }
        }else if(name=='minus'){
            if(props.value.quantity>=1){
                let currentItem = props.articleToList[props.value.id]
                currentItem.quantity = currentItem.quantity = props.value.quantity-1
                props.setArticleToList({...props.articleToList,[props.value.id]:currentItem})
                setErrorAddQte(false)
            }else{
                setErrorAddQte(t('quotaMin'))
            }
        }
    }

    return(
        <>
            <div className={props.style}>
                <div className="row">
                    <div className="col-8">
                        <strong className="fsArticlePos">{props.value.name}</strong>
                        {(props.disponible!=undefined) &&
                            <div className="text-muted small">{t('availableInOriginSection')+' : '+props.disponible}</div>
                        }
                    </div>
                    <div className="col-4">
                        {(props.value && props.value.image) ?
                            <div className='text-end mb-1' style={{maxHeight:'60px'}}>
                                <BtnItemBlockInfo articleId={props.value.id} image={props.value.image} articleName={props.value.name} wmsid={props.posid} />
                            </div>
                        :
                            <div className='text-end mb-1' style={{maxHeight:'60px'}}>
                                <img style={{maxHeight:'50px', maxWidth:'70px'}} src="/assets/images/no-image.png" alt="No image" />
                            </div>
                        }
                    </div>
                </div>
                <div className="row marginLeftArticle">
                    <div className="col">
                        <div className="row">
                            <div className="col-3">
                                <strong>{'x'+props.value.quantity}</strong>
                            </div>
                            <div className="col-9 text-end">
                                <button className="btn btn-success btn-sm sizeBtnPos" onClick={()=>handleClick('plus')} ><FontAwesomeIcon icon={faPlus} /></button>&nbsp;
                                <button className="btn btn-danger btn-sm sizeBtnPos" onClick={()=>handleClick('minus')} ><FontAwesomeIcon icon={faMinus} /></button>&nbsp;&nbsp;
                            </div>
                        </div>
                        {(errorAddQte) && (
                            <div className="row text-danger mt-1">
                                {errorAddQte}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default LineItemToTransform;